<template>
  <div class="contact js">
    <!-- <div class="contact-section">
      <div id="breadcrumbs">
        <nav class="breadcrumbs">
          <span class="breadcrumbs-item">
            <a href="/">
              <span>{{ $t('new.home') }}</span>
            </a>
          </span>
          <span class="breadcrumb-divider" aria-hidden="true">/</span>
        </nav>
      </div>
    </div> -->
    <div class="contact-section">
      <div class="contact-section-cont">
        <div class="contact-section-title">
          <h2 data-animate data-animate-order="1">{{ $t('new.contact') }}</h2>
          <div data-animate data-animate-order="2" class="contact-section-title-div">
            <h5>{{ $t('new.contactTitle1') }}</h5>
          </div>
        </div>
        <div data-animate data-animate-order="3">
          <div class="contact-section-text">
            <div>
              <form @submit.prevent="submitForm" id="contactForm">
                <div class="form-item">
                  <label for="name">{{ $t('new.name') + ' *' }}</label>
                  <input type="text" name="name" :placeholder="$t('new.name') + ' *'" id="name" aria-labelledby="name"
                    data-aid="name-input" required aria-required maxlength>
                </div>
                <div class="form-item">
                  <label for="email">{{ $t('new.email') + ' *' }}</label>
                  <input type="text" name="email" :placeholder="$t('new.email') + ' *'" id="email"
                    aria-labelledby="email" data-aid="email-input" required aria-required maxlength
                    pattern="[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}$" title="请输入有效的邮箱地址">
                </div>
                <div class="form-item">
                  <label for="phone">{{ $t('new.phone') + ' *' }}</label>
                  <input type="text" name="phone" :placeholder="$t('new.phone') + ' *'" id="phone"
                    aria-labelledby="phone" data-aid="phone-input" required aria-required maxlength="20"
                    pattern="[\+]?[0-9]{1,4}[\s\-]?[0-9]{7,15}" title="请输入有效的电话号码">
                </div>
                <div class="form-item">
                  <label for="location">{{ $t('new.location') + ' *' }}</label>
                  <input type="text" name="location" :placeholder="$t('new.location') + ' *'" id="location"
                    aria-labelledby="location" data-aid="location-input" required aria-required maxlength>
                </div>
                <div class="form-item form-item-full">
                  <label for="location">{{ $t('new.message') + ' *' }}</label>
                  <textarea name="message" :placeholder="$t('new.message') + ' *'" id="message"
                    aria-labelledby="message" data-aid="message-input" rows="10" maxlength></textarea>
                </div>
                <div class="contact-btn">
                  <button type="submit" class="btn">{{ $t('new.send') }}</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { submitQuestion } from '@/api/komo'
export default {
  mounted() {
    this.initAnimations();
  },
  methods: {
    initAnimations() {
      // 获取所有带 data-animate 属性的元素
      const animateElements = document.querySelectorAll('[data-animate]');

      animateElements.forEach(element => {
        const order = element.getAttribute('data-animate-order') || 0;
        // 添加延时，按顺序播放动画
        setTimeout(() => {
          element.classList.add('animate-trigger');
        }, order * 300); // 300ms 间隔
      });
    },
    async submitForm() {
      const form = document.getElementById('contactForm');
      // 检查表单有效性
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      const formData = new FormData(form);
      // 将 FormData 转换为普通对象
      const formDataObj = {};
      for (let [key, value] of formData.entries()) {
        formDataObj[key] = value;
      }
      console.log(formDataObj)
      let params = {
        body_option: "consumer",
        full_name: formDataObj.name,
        mobile: formDataObj.phone,
        email: formDataObj.email,
        preferred_city: formDataObj.location,
        message: formDataObj.message
      }

      try {
        // 使用导入的 submitQuestion 方法提交表单数据
        const response = await submitQuestion(params);

        if (response && response.error === 0) {
          // 提交成功处理
          const successMessage = response.message || '提交成功！';
          this.$message.success(successMessage);
          form.reset();
        } else {
          // 提交失败处理
          const errorMessage = response?.message || response?.errors || '提交失败，请重试';
          this.$message.error(errorMessage);
        }
      } catch (error) {
        console.error('提交出错:', error);
        // 检查是否有响应数据
        if (error.response && error.response.data) {
          const errorMsg = error.response.data.message ||
            error.response.data.errors ||
            '提交出错，请重试';
          this.$message.error(errorMsg);
        } else {
          this.$message.error('网络错误，请检查网络连接后重试');
        }
      }
    },
  }
}
</script>
<style lang="scss" scoped>
:root {
  --padding-section-top: 75px;
  --padding-section-bottom: 75px;
}

.contact {
  padding: var(--nav-max-height) 0 0;
  display: block;

  .contact-section {
    width: 100%;

    #breadcrumbs {
      margin: 0;
      padding-top: 15px;
      padding-bottom: 15px;
      padding-left: 60px;
      padding-right: 60px;

      .breadcrumbs {
        font-size: 0;

        .breadcrumbs-item {
          margin-right: 10px;
          display: inline-block;
          font-size: 12px;

          a {
            color: var(--font-color);

            span {
              display: inline-block;
              padding-bottom: 0;
              font-family: var(--label-font-stack);
              font-weight: var(--label-font-weight);
              font-style: var(--label-font-style);
              text-transform: var(--label-font-case);
              letter-spacing: var(--label-spacing);
            }
          }
        }

        .breadcrumb-divider {
          font-size: 12px;
        }
      }
    }

    .contact-section-cont {
      padding-top: var(--padding-section-top);
      padding-bottom: var(--padding-section-bottom);
      padding-left: 60px;
      padding-right: 60px;

      .contact-section-title {
        align-items: center;
        display: flex;
        flex-direction: column;
        max-width: 920px;
        margin: 0 auto 50px;

        h2 {
          font-size: var(--h2-size);
          margin: 0;
          width: 100%;
          max-width: 80ch;
          text-align: center;
          color: var(--font-color);
        }

        .contact-section-title-div {
          width: 100%;
          max-width: 80ch;
          margin: 15px 0 0;

          h5 {
            margin-bottom: 0;
            font-size: var(--h5-size);
            text-align: center;
            color: var(--font-color);
          }
        }
      }

      .contact-section-text {
        max-width: 920px;
        margin: 0 auto;

        form {
          display: flex;
          flex-wrap: wrap;
          row-gap: 15px;
          column-gap: 20px;
          margin-bottom: 0;

          .form-item {
            width: 100%;
            display: flex;
            flex-direction: column;

            label {
              position: absolute;
              width: 1px;
              height: 1px;
              padding: 0;
              margin: -1px;
              overflow: hidden;
              clip: rect(0, 0, 0, 0);
              border: 0;
              cursor: pointer;
            }

            input {
              color: var(--font-color);
              font-size: var(--base-font-size);
              line-height: 1.6;
              font-family: var(--body-font-stack);
              font-weight: var(--body-font-weight);
              font-style: var(--body-font-style);
              -webkit-font-smoothing: antialiased;
              -webkit-text-size-adjust: 100%;
              background: 0 0;
              max-width: 100%;

              &:focus,
              &:focus-visible {
                outline: 0;
              }
            }

            textarea {
              color: var(--font-color);
              font-size: var(--base-font-size);
              line-height: 1.6;
              font-family: var(--body-font-stack);
              font-weight: var(--body-font-weight);
              font-style: var(--body-font-style);
              -webkit-font-smoothing: antialiased;
              -webkit-text-size-adjust: 100%;
              background: 0 0;
              max-width: 100%;
              border-radius: var(--block-border-radius);
              scrollbar-width: thin;
              scrollbar-color: var(--text-color-transparent40) var(--text-color-transparent10);
              min-height: 100px;
              border: 1px solid var(--border-color);
              padding: 10px;

              &:focus,
              &:focus-visible {
                outline: 0;
              }
            }
          }

          .form-item-full {
            width: 100% !important;
          }

          .contact-btn {
            width: 100%;

            .btn {
              user-select: none;
              display: inline-block;
              padding: 10px calc(15px + 20px);
              width: auto;
              margin: 0;
              position: relative;
              overflow: hidden;
              text-decoration: none;
              text-align: center;
              vertical-align: middle;
              line-height: 1.6;
              cursor: pointer;
              border: 0;
              -webkit-appearance: none;
              -moz-appearance: none;
              border-radius: var(--alt-btn-border-radius);
              background-color: rgba(66 43 32 / 1.0);
              color: rgba(232 226 217 / 1.0);
              font-family: var(--button-font-stack);
              font-weight: var(--button-font-weight);
              font-style: var(--button-font-style);
              text-transform: uppercase;
              font-size: 14px;
              letter-spacing: 2px;
            }

            .btn:not(:disabled):not(.standalone-icon--wrapper):not(.swiper-button-disabled):not(.disabled):not(.btn--secondary):hover:after {
              background-image: linear-gradient(90deg, transparent, hsla(0, 0%, 100%, .25), transparent);
              content: "";
              height: 100%;
              left: 150%;
              position: absolute;
              top: 0;
              transform: skew(-20deg);
              width: 200%;
              animation: shineAgain .75s cubic-bezier(.01, .56, 1, 1);
            }
          }
        }
      }
    }
  }
}

@media only screen and (min-width: 768px) {
  .breadcrumbs a {
    background-color: transparent !important;
    background-image: linear-gradient(to top, currentColor 0, currentColor 0), linear-gradient(to top, transparent 0, transparent 0);
    background-repeat: no-repeat;
    background-position: left bottom, left bottom;
    background-size: 0 1px, 100% 1px;
    transition-property: background-size;
    transition-timing-function: ease;
    transition-duration: .25s;
  }

  .breadcrumbs a:hover {
    background-position: left bottom, left bottom;
    background-size: 100% 1px, 100% 1px;
  }

  .contact .contact-section .contact-section-cont .contact-section-text form .form-item {
    width: calc(50% - 10px);
  }

}

@media (max-width: 765px) {
  .contact .contact-section {
    #breadcrumbs {
      padding: 15px;
    }

    .contact-section-cont {
      padding-left: 15px;
      padding-right: 15px;
    }
  }
}

@media (max-width: 1115px) {
  .contact {
    padding: var(--nav-1115-height) 0 0;
  }
}

@media (max-width: 990px) {
  .contact {
    padding: var(--nav-990-height) 0 0;
  }
}
</style>